<template>
    <div>
        <div class="block relative z-10 faded border p-3 rounded-lg bg-white border-gray-300">
            <div class="flex" :class="{ 'text-sm text-gray-500 mb-1': account.settlement_balance !== null }">
                <div class="flex-auto font-medium">
                    Original Balance:
                </div>
                <div class="flex-auto font-semibold text-right">
                    {{ account.original_balance | money }}
                </div>
            </div>

            <div v-if="account.settlement_balance" class="flex">
                <div class="flex-auto font-medium">
                    Offered Balance:
                </div>
                <div class="flex-auto font-semibold text-right">
                    {{ account.settlement_balance | money }}
                </div>
            </div>

            <div class="mt-1 bg-gray-100 border-gray-200 border w-full rounded-full">
                <div :class="`bg-green-500 py-1.5 rounded-full`" :style="{ 'width': `${percentPaid}%` }" />
            </div>
        </div>
        <div class="flex bg-gray-200 border-gray-300 text-black font-medium faded z-0 relative -top-2 -mb-2 border p-1 pt-4 px-3 rounded-b-lg">
            <div class="flex-auto">
                <p class="text-sm">
                    <span class="font-semibold">Paid:</span> {{ account.total_paid | money }}
                </p>
            </div>
            <div class="flex-auto text-right">
                <p class="text-sm">
                    <span class="font-semibold">Remaining:</span> {{ account.current_balance | money }}
                </p>
            </div>
        </div>

        <a v-if="! declinedStatus && (billingProfile && ! billingProfile.is_card_expiring_within_days)" @click.prevent="$root.$emit('update-billing-profile', billingProfile)" class="inline-block mt-4 text-center w-full text-blue-600 py-3 px-4 border border-blue-600 shadow-sm leading-4 shadow rounded-md focus:outline-none bg-white hover:bg-blue-100 cursor-pointer text-sm">
            <span class="font-medium underline">Change Card or Checking Information</span>
        </a>
        <a v-else-if="billingProfile && ! declinedStatus" @click.prevent="$root.$emit('update-billing-profile', billingProfile)" class="inline-block mt-4 leading-relaxed text-center w-full text-white py-3 px-4 border border-red-600 shadow-sm leading-4 rounded-md focus:outline-none bg-red-500 hover:bg-red-600 cursor-pointer text-sm">
            {{ billingProfile.cc_type }} ending {{ billingProfile.cc_last_four }} expiring soon<br /><span class="font-semibold underline">Change Card or Checking Information</span>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            account: {},
            billingProfile: {},
            declinedStatus: {},
        },

        computed: {
            /**
             * @returns {Number}
             */
            amountPaid() {
                return this.account.total_paid;
            },

            /**
             * @returns {Number}
             */
            amountRemaining() {
                if (this.account.settlement_balance !== null) {
                    return Number(this.account.settlement_balance) - Number(this.amountPaid);
                }

                return Number(this.account.original_balance) - Number(this.amountPaid);
            },

            /**
             * @returns {String}
             */
            percentPaid() {
                let balance = this.account.settlement_balance || this.account.original_balance;

                let percent = (this.amountPaid / balance) * 100;

                return percent.toFixed(0);
            }
        }
    }
</script>